// extracted by mini-css-extract-plugin
export default {"resizableGrid":"resizableGrid_resizableGrid__ci+jj","resizableGridMaxHeight":"resizableGrid_resizableGridMaxHeight__gBgOE"};